import Model from '@/Models/Contracts/Model';
export default class FieldCategory extends Model {
    constructor() {
        super(...arguments);
        this.isOpen = false;
    }
    resource() {
        return 'field-categories';
    }
    get filteredFields() {
        if (auth.user.is_admin) {
            return this.fields;
        }
        return this.fields.filter(field => !field.is_admin_only);
    }
}
